import { getDayRow, mapAgendas } from "../utils"

const dayOne = `08:45 - 10:00	Keynote: Harnessing the Power of Positivity
10:15 - 11:00	V1.2 Looking Beyond Zero Trust to Cybersecurity Mesh Architecture
11:30 - 12:15	V2.2 ThreatLocker: How to Create Successful Malware and Defend with Zero Trust
13:30 - 14:15 	V3.2 SureCloud: Beyond Monitoring: Integrating Continuous Control Monitoring with GRC for comprehensive Cyber Resilience
14:30 - 15:15	V4.2 ISF Assure – An Introduction
15:45 - 16:30 	V5.2 Dealing with Risks and Uncertainty: The psychological phenomena that influence your security risk assessments
16:45 - 17:45	Keynote: Robot Ethics and the Future of Human-Robot Interaction`

const dayTwo = `09:00 - 10:00	Keynote: Embedding a Culture of Innovation into Everyone’s DNA
10:15 - 11:00	V6.2 Telenor’s Journey into Establishing a Security Threat Intelligence Radar
11:30 - 12:15	V7.2 SecurityScorecard: Cyber Resiliency in the Supply Chain: Navigating risks amid global disruptions
13:30 - 14:15 	V8.2 Outsourcing Securely: Essential steps to ensure success
14:30 - 15:15	V9.2 A Secure Supply Chain - To be or not to be
15:45 - 16:45 	Keynote: How to Think Like a Hacker and Help Your Organisation Handle Incidents
16:45 - 17:45	Panel Discussion: Hacking ICS and handling OT incidents`

const dayThree = `09:00 - 10:00	Keynote: The State of Security: Using pressure to prosper as a security leader
10:15 - 11:00	V10.2 Threat Intelligence: The difference between winning and losing
11:30 - 12:30	Keynote: The Power of Choice`

export default function auditoriumTwo() {
    const now = new Date()

    const dates = [
        { day: new Date("2025-06-02 00:00:00.000-05:00"), sessions: mapAgendas("2025-06-02", dayOne) },
        { day: new Date("2025-06-03 08:00:00.000-05:00"), sessions: mapAgendas("2025-06-03", dayTwo) },
        { day: new Date("2025-06-04 08:00:00.000-05:00"), sessions: mapAgendas("2025-06-04", dayThree) }
    ]

    return getDayRow(dates, it => it.day, now)?.sessions?.map(([start, end, title]) => {
        return 	{
            start,
            end,
            title,
            room: "Auditorium-two",
            path: "/auditorium-two",
        }
    })
}